import { Box, Icon, useTheme, Typography } from '../../../base';
import { IJob } from '../../../common';
import { StyledLabel } from './HeaderLabels.styles';

interface Props {
    jobObject: IJob;
}
const HeaderLabels = (props: Props) => {
    const { jobObject } = props;
    const theme = useTheme();

    const getIconName = (attr: string) => {
        switch (attr) {
            case 'Job Type':
                return 'WorkOutlineOutlinedIcon';
            case 'Employment Type':
                return 'BadgeOutlinedIcon';
            case 'Employment Period':
                return 'AccessTimeOutlinedIcon';
            default:
                return 'WorkOutlineOutlinedIcon';
        }
    };
    return (
        <Box
            display="flex"
            alignItems="center"
            flexWrap="wrap"
            sx={{
                marginTop: theme.spacing(2),
            }}
        >
            {jobObject.location && (
                <StyledLabel>
                    <Icon name={'LocationOnOutlinedIcon'} size={16} />
                    <Typography
                        variant={'body2'}
                        sx={{ marginInlineStart: theme.spacing(0.5) }}
                    >
                        {jobObject.location}
                    </Typography>
                </StyledLabel>
            )}
            {jobObject.jobAttributes?.map((attribute) => (
                <StyledLabel key={attribute.jobAttributeOption.name}>
                    <Icon
                        name={getIconName(attribute.jobAttributeOption.name)}
                        size={16}
                    />
                    <Typography
                        variant={'body2'}
                        sx={{ marginInlineStart: theme.spacing(0.5) }}
                    >
                        {attribute.jobAttributeValue.name}
                    </Typography>
                </StyledLabel>
            ))}
        </Box>
    );
};

export default HeaderLabels;
